// KitList.tsx
import React from 'react'
import { IconButton } from '../../../../../../common/components/iconButton/IconButton'
import { SaleItemInterface } from '../../../../../../common/types/interfaces'
import { Input } from '../../../../../../common/components/input/Input'
import del from '../../../../../../assets/images/icons/trash.svg'
import classes from './KitList.module.sass'

type Props = {
  items?: Array<{ childItemId: number; quantity: number; item?: SaleItemInterface }>
  saleItemList: SaleItemInterface[]
  onRemove: (childItemId: number) => void
  onQuantityChange: (childItemId: number, quantity: number) => void
  getItemDisplayText: (item: SaleItemInterface) => string
  title: string
}

export const KitList = ({
  items,
  saleItemList,
  onRemove,
  onQuantityChange,
  getItemDisplayText,
  title,
}: Props) => {
  if (!items?.length) return null

  const handleQuantityChange =
    (childItemId: number) => (value: any, fieldName: string, type: string) => {
      const strValue = String(value)
      let filtered = strValue.replace(/\D/g, '')
      filtered = filtered.replace(/^0+/, '')

      if (filtered === '') {
        onQuantityChange(childItemId, 0)
        return
      }

      const num = Number(filtered)
      if (!isNaN(num) && num > 0) {
        onQuantityChange(childItemId, num)
      }
    }
  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      <div className={classes.list}>
        {items.map((kitItem) => {
          const product = kitItem.item || saleItemList.find((p) => p.id === kitItem.childItemId)
          if (!product) return null

          return (
            <div className={classes.item} key={kitItem.childItemId}>
              <span className={classes.itemName}>{getItemDisplayText(product)}</span>
              <div className={classes.controls}>
                <div className={classes.quantityInput}>
                  <Input
                    type={'numberText'}
                    fieldName={`kit_${kitItem.childItemId}`}
                    value={kitItem.quantity === 0 ? '' : String(kitItem.quantity)}
                    placeHolder="Кол-во"
                    onChangeHandler={handleQuantityChange(kitItem.childItemId)}
                  />
                </div>
               
              </div>
               <IconButton
                  onClick={() => onRemove(kitItem.childItemId)}
                  alt="Удалить"
                  display
                  icon={del}
                  small
                />
            </div>
          )
        })}
      </div>
    </div>
  )
}
